<template>
  <span class="booking-status-indicator">
    <md-icon class="status-icon" :class="statusClass">privacy_tip</md-icon>
    <span v-if="showText">{{ statusDescription }}</span>
  </span>
</template>

<script>
const BOOKING_STATUS_CLASS_MAP = {
  pending: "attention",
  reserved: "primary",
  attempted: "warning",
  partially_paid: "partial",
  fully_paid: "success",
  abandoned: "abandoned",
  cancelled: "danger",
  cancelled_credit: "danger"
};

export default {
  name: "BookingStatus",
  props: {
    statusValue: { type: String, default: "" },
    statusDescription: { type: String, default: "" },
    showText: { type: Boolean, default: true }
  },
  computed: {
    statusClass() {
      return BOOKING_STATUS_CLASS_MAP[this.statusValue] || "default";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.booking-status-indicator {
  display: inline-flex;
  align-items: center;
}

.status-icon {
  margin-right: 4px;

  &.primary {
    color: $brand-primary !important;
  }
  &.success {
    color: $brand-success !important;
  }
  &.warning {
    color: $brand-warning !important;
  }
  &.danger {
    color: $brand-danger !important;
  }
  &.attention {
    color: $brand-purple !important;
  }
  &.partial {
    color: $amber-500 !important;
  }
  &.default {
    color: $gray-color !important;
  }
  &.abandoned {
    color: $blue-grey-500 !important;
  }
}
</style>
